import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { map, Observable } from 'rxjs';

import { AlertService } from '@app/services';

import { MBannerComponent, MBannerType } from '@mercadona/components-musi/banner';

@Component({
  selector: 'app-alert',
  imports: [AsyncPipe, MBannerComponent],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  color$: Observable<MBannerType> = this.alertService.color$.pipe(
    map((c) => (c === 'alert' || c === 'warning' || c === 'info' ? c : 'info'))
  );

  constructor(public alertService: AlertService) {}

  onCloseIconClick() {
    this.alertService.dismiss();
  }
}
